// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSelfStudyStatsForAcademicYearDashboardHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AcademicYearSelfStudyStatsDTO from '../models/AcademicYearSelfStudyStatsDTO';
import AcademicYearDTO from '../models/AcademicYearDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYear: number;
    rppId: number | null | null;
    districtId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYear: 0,
            rppId: null,
            districtId: null,
        },
        initValues);
    },
    academicYear: 'academicYear',
    rppId: 'rppId',
    districtId: 'districtId',
}

interface Result extends ResultDTO {
    stats: AcademicYearSelfStudyStatsDTO | null;
    academicYear: AcademicYearDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            stats: null,
            academicYear: null,
        },
        initValues);
    },
    stats: 'stats',
    academicYear: 'academicYear',
}

export { Request, Result };